import * as React from 'react';

const svgReaded = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1433 7.14291V7.78152C18.7327 8.19261 20.715 10.4359 20.715 13.1432V14.3361C20.715 15.9576 21.2686 17.5327 22.2793 18.8006L22.8115 19.465C23.0187 19.7221 23.0579 20.0757 22.9151 20.3721C22.7722 20.6686 22.4722 20.8579 22.1436 20.8579H7.85719C7.52753 20.8579 7.22734 20.6686 7.08462 20.3721C6.94186 20.0757 6.98201 19.7221 7.18787 19.465L7.7204 18.8006C8.73366 17.5327 9.28583 15.9576 9.28583 14.3361V13.1432C9.28583 10.4359 11.2681 8.19261 13.8575 7.78152V7.14291C13.8575 6.51181 14.3682 6 15.0004 6C15.6326 6 16.1433 6.51181 16.1433 7.14291ZM14.7147 9.42874C12.6646 9.42874 11.0002 11.0931 11.0002 13.1432V14.3361C11.0002 16.0469 10.5045 17.7149 9.58263 19.1435H20.4185C19.4971 17.7149 19.0006 16.0469 19.0006 14.3361V13.1432C19.0006 11.0931 17.3362 9.42874 15.2861 9.42874H14.7147ZM17.2862 22.0008C17.2862 22.5758 17.0469 23.1901 16.6183 23.6187C16.1897 24.0473 15.5754 24.2866 15.0004 24.2866C14.3932 24.2866 13.8111 24.0473 13.3825 23.6187C12.9539 23.1901 12.7146 22.5758 12.7146 22.0008H17.2862Z"
      fill="white"
    />
    <path
      d="M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

const svgUnreaded = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1433 7.14291V7.78152C18.7327 8.19261 20.715 10.4359 20.715 13.1432V14.3361C20.715 15.9576 21.2686 17.5327 22.2793 18.8006L22.8115 19.465C23.0187 19.7221 23.0579 20.0757 22.9151 20.3721C22.7722 20.6686 22.4722 20.8579 22.1436 20.8579H7.85719C7.52753 20.8579 7.22734 20.6686 7.08462 20.3721C6.94186 20.0757 6.98201 19.7221 7.18787 19.465L7.7204 18.8006C8.73366 17.5327 9.28583 15.9576 9.28583 14.3361V13.1432C9.28583 10.4359 11.2681 8.19261 13.8575 7.78152V7.14291C13.8575 6.51181 14.3682 6 15.0004 6C15.6326 6 16.1433 6.51181 16.1433 7.14291ZM14.7147 9.42874C12.6646 9.42874 11.0002 11.0931 11.0002 13.1432V14.3361C11.0002 16.0469 10.5045 17.7149 9.58263 19.1435H20.4185C19.4971 17.7149 19.0006 16.0469 19.0006 14.3361V13.1432C19.0006 11.0931 17.3362 9.42874 15.2861 9.42874H14.7147ZM17.2862 22.0008C17.2862 22.5758 17.0469 23.1901 16.6183 23.6187C16.1897 24.0473 15.5754 24.2866 15.0004 24.2866C14.3932 24.2866 13.8111 24.0473 13.3825 23.6187C12.9539 23.1901 12.7146 22.5758 12.7146 22.0008H17.2862Z"
      fill="red"
    />
    <path
      d="M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z"
      stroke="red"
      strokeWidth="2"
    />
  </svg>
);

interface Props {
  unread?: boolean;
}

export default (props: Props) => {
  const {unread} = props;
  if (unread) {
    return svgUnreaded;
  }
  return svgReaded;
};
